import { render, staticRenderFns } from "./ControllerSet.vue?vue&type=template&id=b544bf24&scoped=true"
import script from "./ControllerSet.vue?vue&type=script&lang=js"
export * from "./ControllerSet.vue?vue&type=script&lang=js"
import style0 from "./ControllerSet.vue?vue&type=style&index=0&id=b544bf24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b544bf24",
  null
  
)

export default component.exports